import React, { useState } from 'react';
import { Box, Button, Typography, CircularProgress, Select, MenuItem, TextField } from '@material-ui/core';
import Dialog from '../../../views/dialog';
import useStyles from './style';
import warning from '../../../assets/images/warning.svg';
import error from '../../../assets/images/error.svg';
import { configMessage } from '../../messages/config';

function PromptDialog(props) {
  const classes = useStyles();

  const { showFooter = true, loading = false, primaryText, secondaryText } = props;

  const [selectedValue, setSelectedValue] = useState("");

  const [text,setText] = useState("");
  const [error,setError] = useState(false)

  const getSelectedName = () => {
    const selectedItem = props.data.list.find((item) => item.uid === selectedValue);
    return selectedItem ? selectedItem.name : "Select an option";
  };
  const getSelectedLaneName = () => {
    const selectedItem = props.data.list.find((item) => item.uid === selectedValue);
    return selectedItem ? selectedItem.laneName : "";
  };
  const getSelectedGroupName = () => {
    const selectedItem = props.data.list.find((item) => item.uid === selectedValue);
    return selectedItem&&selectedItem.groupName ? selectedItem.groupName : "";
  };

  const handleChange = (e)=>{
    setError(false)
    setSelectedValue(e.target.value)
    setText(e.target.value)
  }

  let title = (
    <Box className={classes.titleBox}>
      <Typography variant='h2'>
        {props.data.action && (
          <Box component='span' className={classes.icons}>
            {props.data.action === 'error' ? (
              <img src={error} alt='' />
            ) : (
              <img src={warning} alt='' />
            )}
          </Box>
        )}
        {props.data.title}
      </Typography>
      <Box className={classes.contentTxt}>
        <Typography variant='h3' classes={{ root: classes.contentTypography }}>
          {props.data.text}
        </Typography>
      </Box>
      {props?.data?.list && (
      <Box>
        <Select
          fullWidth
          defaultValue=""
          displayEmpty
          renderValue={() => getSelectedName()}
          onChange={handleChange}
        >
          {props.data.list.map((item) => (
            <MenuItem key={item.uid} value={item.uid}>
              {item.name} ( {item.laneName}{item.groupName?` / ${item.groupName}`:""} )
            </MenuItem>
          ))}
        </Select>
      </Box>
    )}
      {
        (props.data.title === configMessage.L4671 && props.data.type !== "error") ?   <Box className={classes.containerBox} style={{marginTop:"10px"}}>
          <Typography className={classes.label} style={{margin:"0px"}}>
            Reason
          </Typography>
          <TextField
            className={classes.textBox}
            variant="outlined"
            placeholder="Enter your reason here"
            value={text}
            onChange={handleChange}
            style={{margin:"0px"}}
            error={error} 
            // helperText={error ? "Please enter a reason to revert." : ""}
          />
          {
            error ?    <Typography  style={{margin:"0px",color:"red",fontSize:"12px", backgroundColor: 'transparent'}}>
            Please enter a reason to revert.
        </Typography>:""
          }
        
  
      </Box> : ""
      }
   
    </Box>
  );

  let loader = (
    <CircularProgress classes={{ root: classes.loader }} size={24} />
  );

  let content = '';

  let footer = (
    <Box className={classes.btnCntrls}>
      {secondaryText !== "" &&
      <Button
        variant='contained'
        color='secondary'
        onClick={(e) =>{
          props.close()
          if(typeof props.no =='function'){
            props.no(e);
          }
        } 
      }
      >
        {secondaryText || "No"}
      </Button>
      }
      { primaryText !== "" &&
      <Button
        variant='contained'
        color='primary'
        onClick={(e) => {
          props.close();
          if(props.data?.list && props.data?.list.length){
            console.log("selectedValue",selectedValue)
            console.log("selectedName",getSelectedName(selectedValue))
            const name = getSelectedName(selectedValue)
            const laneName = getSelectedLaneName(selectedValue)
            const groupName = getSelectedGroupName(selectedValue)
            props.yes(e, selectedValue+"#"+name+"#"+laneName+"#"+groupName);
          }
          else{
          if(props.data.title === configMessage.L4671){
            if(props.data.type !== "error"){
              if(text){
                props.close();
                props.yes(e, props.data.name , text , true);
              }
              else{
                setError(true)
              }
            }
            else{
                props.close();
                props.yes(e, props.data.name ,"",false);
            }
          }
          else{
            props.close();
            props.yes(e, props.data.name);
          }
        }}}
      > 
      {primaryText || "Yes"}
      </Button>
      }
    </Box>
  );

  return (
    <Dialog
      open={props.open}
      onClose={props.close}
      clicked={props.close}
      maxWidth={'sm'}
      fullWidth={true}
      dialogTitle={loading ? loader : title}
      dialogoContent={content}
      dialogFooter={showFooter ? footer : []}
    />
  );
}
export default PromptDialog;
